<template>
  <!--
    * Treeview component of Vuetify
    - items로 전달한 데이터에 맞춰 트리구조를 생성
    - 전달 데이터는 '[{},{},..]'의 구조이며, object 내부의 'children'컬럼을 통해 상하관계를 판단함
    - 트리뷰 태그는 그 자체로 v-for와 같은 역할, 태그 내부는 하나의 행임
    - 조직도 내부에 조직원 목록을 함께 표기해야하므로 조건별 slot 사용
      ( prepend, append = 조직 | label = 조직원 인사정보 )
   -->

  <v-treeview
    :items="searchList"
    open-on-click
    :open="initiallyOpen"
    item-key="seq"
    expand-icon=""
    class="overflow-y-auto overflow-x-hidden bt-line"
    ref="treeView"
  >
    <!-- 1. 좌측 : 조직명 표기 -->
    <template v-slot:prepend="{ item }">
      <div v-if="item.children">
        <span
          class="depth-title"
          :style="`color: ${titleColorCode(item.treeLevel)}`"
        >
          <span :style="`background: ${titleColorCode(item.treeLevel)}`"></span>
          {{ item.orgNm }}
        </span>
      </div>
    </template>

    <!-- 2. 가운데 : 인사정보 표기 -->
    <template v-slot:label="{ item }">
      <v-sheet
        v-if="!item.children"
        elevation="0"
        class="pa-0 ma-0"
        color="#f4f6f7"
        style="background-color: #f4f6f7"
      >
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <!-- 2-A. 조직원이 없는 (최하위레벨의)조직일 경우 -->
            <v-list-item v-if="item.emptyFlag">
              <v-list-item-content class="pa-0 text-center non-member">
                <div>
                  <v-icon size="18">mdi-magnify</v-icon>
                  <span class="desc">조직원이 없습니다.</span>
                </div>
              </v-list-item-content>
            </v-list-item>

            <!-- 2-B. 조직원 인사정보 -->
            <v-list-item v-else class="px-0 member-list">
              <v-list-item-icon @click="$emit('clickMemberItem', item)">
                <v-avatar>
                  <img v-if="getImgSrc(item) !== ''" :src="getImgSrc(item)" alt="employees.name" />
                </v-avatar>
              </v-list-item-icon>

              <v-list-item-content
                class="pa-0"
                @click="$emit('clickMemberItem', item)"
              >
                <v-list-item-title>
                  <span class="name">{{ item.empName }}</span>
                  <span class="divider position">{{ item.jikweeNm }}</span>
                </v-list-item-title>
                <v-list-item-subtitle class="position">
                  {{ item.orgNm }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon class="btn-wrap" v-if="item.contPhone != null">
                <v-btn
                  color="#eaebec"
                  elevation="0"
                  width="40"
                  min-width="40"
                  height="40"
                  @click="callSms(item.contPhone.replace(/-/g, ''))"
                >
                  <v-icon size="18">mdi-message-processing-outline</v-icon>
                </v-btn>

                <v-btn
                  color="#eaebec"
                  elevation="0"
                  width="40"
                  min-width="40"
                  height="40"
                  @click="callTel(item.contPhone.replace(/-/g, ''))"
                >
                  <v-icon size="18">mdi-phone-outline</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-col>
        </v-row>
      </v-sheet>
    </template>

    <!-- 3. 우측 : arrow icon 표기 -->
    <template v-slot:append="{ item, open }">
      <div v-show="item.children && item.children.length">
        <v-icon v-text="`mdi-${open ? 'chevron-up' : 'chevron-down'}`"></v-icon>
      </div>
    </template>
  </v-treeview>
</template>

<script>
/* 조직도 트리목록 컴포넌트 */
export default {
  props: {
    searchList: {
      type: Array,
    },
  },
  data: () => ({
    initiallyOpen: [1], // tree open value
  }),
  computed: {
    /* 이미지 가져오기 */
    // getImgSrc() {
    //   return item => {
    //     return item.bFileNm !== null
    //       ? this.$domain + 'api/file/profile?fileName=' + item.bFileNm +'&enterCd=' + item.enterCd
    //       : /*
    //     return item.fileId != null && item.seqNo != null
    //       ? this.$domain +
    //           '/cloudhr/1.0/file/display?fileId=' +
    //           item.fileId +
    //           '&seqNo=' +
    //           item.seqNo
    //     */
    //         require('@/assets/img/profile_none.png');
    //   };
    // },
  },
  beforeUpdate() {
    //alert('Loading');
  },
  async updated() {
    //this.$refs.treeView.updateAll(true);
    //alert('Loading End');
  },
  methods: {
    /* 타이틀 컬러코드 추출 */
    titleColorCode(treeLevel) {
      return treeLevel === 1
        ? '#3cb149'
        : treeLevel === 2
        ? '#111'
        : treeLevel === 3
        ? '#363C43'
        : '#565C63';
    },

    callSms(num) {
      window.bizMOB.System.callSMS({
        "_aNumber" : [num],
        "_sMessage" : "",
        "_fCallback" : function(res) {
          // console.log('callSms : '+JSON.stringify(res));
        }
      });
    },

    callTel(num) {
      window.bizMOB.System.callTEL({
        "_sNumber" : num,
        "_fCallback" : function(res) {
          // console.log(JSON.stringify(res));
        }
      });
    },

    getImgSrc(item){
      return (item.sFileNm !== null && item.sFileNm !== '')
          ? this.$domain + 'api/file/profile?fileName=' + item.sFileNm + '&enterCd=' + item.enterCd
          : '';
    },
  },
};
</script>

<style>
/* _memberSearch.scss > tree부분 참고 */
/* #087ef7 #054c94 #21bf54 #12692e */
</style>
